<div class="" *ngIf="visible" (click)="closeModalWindow()" [ngClass]="isCalendar?'page1':'page'" >
  <div class="modal" (click)="$event.stopPropagation();" [ngStyle]="{width: width+'px'}" ngDraggable [handle]="myHandle">
    <div class="modal_header" #myHandle>
      <div class="modal_header_title">{{title}}</div>
      <div class="modal_header_close" (click)="closeModalWindow()">&#10005;</div>
    </div>
    <div class="modal_body" [ngClass]="scrollbar ? 'absolute' : 'static'" [ngStyle]="bodyStyles">
      <div class="modal_body_content">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
